import { produce } from "immer";
import {
  FETCH_CARE_HOME_GROUPS,
  FETCH_CARE_HOME_GROUPS_SUCCESS,
  FETCH_CARE_HOME_GROUPS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_CARE_HOME_GROUP,
  ADD_CARE_HOME_GROUP_SUCCESS,
  ADD_CARE_HOME_GROUP_FAILURE,
  //
  EDIT_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP_SUCCESS,
  EDIT_CARE_HOME_GROUP_FAILURE,
  //
  DELETE_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP_SUCCESS,
  DELETE_CARE_HOME_GROUP_FAILURE,
  //
  SEARCH_CARE_HOME_GROUP,
  SEARCH_CARE_HOME_GROUP_SUCCESS,
  SEARCH_CARE_HOME_GROUP_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingCareHomeGroups: false,
  careHomeGroups: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentCareHomeGroup: {},
  isSearching: false,
  searchHomeGroupList: [],
  // Delete
  isDeleting: false,
};

const CareHomeGroupsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_CARE_HOME_GROUPS:
        draft.isFetchingCareHomeGroups = true;
        draft.currentCareHomeGroup = {};
        break;
      case FETCH_CARE_HOME_GROUPS_SUCCESS:
        draft.isFetchingCareHomeGroups = false;
        draft.careHomeGroups = action.payload;
        break;
      case FETCH_CARE_HOME_GROUPS_FAILURE:
        draft.isFetchingCareHomeGroups = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentCareHomeGroup = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentCareHomeGroup = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_CARE_HOME_GROUP:
        draft.isSubmitting = true;
        break;
      case ADD_CARE_HOME_GROUP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_CARE_HOME_GROUP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_CARE_HOME_GROUP:
        draft.isSubmitting = true;
        break;
      case EDIT_CARE_HOME_GROUP_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_CARE_HOME_GROUP_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_CARE_HOME_GROUP:
        draft.isDeleting = true;
        break;
      case DELETE_CARE_HOME_GROUP_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_CARE_HOME_GROUP_FAILURE:
        draft.isDeleting = false;
        break;
      //search
      case SEARCH_CARE_HOME_GROUP:
        draft.isSearching = true;
        draft.searchHomeGroupList = [];
        break;
      case SEARCH_CARE_HOME_GROUP_SUCCESS:
        draft.isSearching = false;
        draft.searchHomeGroupList = action.payload;
        break;
      case SEARCH_CARE_HOME_GROUP_FAILURE:
        draft.isSearching = false;
        draft.searchHomeGroupList = [];
        break;
      default:
        return state;
    }
  });

export default CareHomeGroupsReducer;
